var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"hero is-primary"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._t("title")],2),_c('h2',{staticClass:"subtitle"},[_vm._t("subtitle")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }